<sh-coralogix-sidebar #sidebarComponent [templateRef]="editor"></sh-coralogix-sidebar>
<ng-template #editor>
  <sh-reindex-form
    [form]="form"
    [logsSeverityOptions]="logsSeverityOptions"
    (Submit)="submit($event)"
  ></sh-reindex-form>
</ng-template>
